import React from 'react';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Core components
import Typography from 'components/core/Typography';
// Custom
import { installationDataShape, scenarioDataShape } from 'constants/PropTypesShapes';
import Callout from 'components/misc/Callout';
import InformationItem from 'components/items/InformationItem';
import ScenarioInformationItem from 'installations/assets/scenarios/ScenarioInformationItem';
import AntipassbackScenarioTriggers from './AntipassbackScenarioTriggers';

const AntipassbackDetails = ({ currentInstallation, scenarios }) => {
  // Build antipassback from installation and scenarios information
  const antipassback = {
    enabledEntrance: currentInstallation.antipassback.enabled_entrance,
    enabledExit: currentInstallation.antipassback.enabled_exit,
    requiredEntrance: currentInstallation.antipassback.required_entrance,
    requiredExit: currentInstallation.antipassback.required_exit,
    scenarios: _filter(scenarios, ['involved_in_antipassback', true]),
  };

  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <Typography type="subtitle2">
          <LocalizedMessage id="info.entrance" />
        </Typography>
        <div className="row information-item-wrapper">
          <div className="col-12 col-sm-6">
            <InformationItem
              label=""
              value={<LocalizedMessage id="field.activeM" />}
              icon={antipassback.enabledEntrance ? 'checkActive' : 'checkInactive'}
            />
          </div>
          <div className="col-12 col-sm-6">
            <InformationItem
              label=""
              value={<LocalizedMessage id="field.required" />}
              icon={antipassback.requiredEntrance ? 'checkActive' : 'checkInactive'}
            />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6">
        <Typography type="subtitle2">
          <LocalizedMessage id="info.exit" />
        </Typography>
        <div className="row information-item-wrapper">
          <div className="col-12 col-sm-6">
            <InformationItem
              label=""
              value={<LocalizedMessage id="field.activeM" />}
              icon={antipassback.enabledExit ? 'checkActive' : 'checkInactive'}
            />
          </div>
          <div className="col-12 col-sm-6">
            <InformationItem
              label=""
              value={<LocalizedMessage id="field.required" />}
              icon={antipassback.requiredExit ? 'checkActive' : 'checkInactive'}
            />
          </div>
        </div>
      </div>
      <div className="col-12 pt-3">
        <Callout>
          <LocalizedMessage id="info.concernedScenarios" />
        </Callout>
      </div>
      {_map(antipassback.scenarios, (scenario) => (
        <div key={scenario.id} className="col-12 col-md-6">
          <ScenarioInformationItem scenario={scenario} />
        </div>
      ))}
      {_isEmpty(antipassback.scenarios) && (
        <div className="col-12 pt-3 pl-4">
          <em><LocalizedMessage id="info.noScenario" /></em>
        </div>
      )}
      <div className="col-12 pt-4">
        <AntipassbackScenarioTriggers
          scenarios={antipassback.scenarios}
        />
      </div>
    </div>
  );
};

AntipassbackDetails.propTypes = {
  currentInstallation: installationDataShape.isRequired,
  scenarios: PropTypes.arrayOf(scenarioDataShape).isRequired,
};

const mapStateToProps = (state) => ({
  currentInstallation: state.installation.current.data,
  scenarios: state.installationScenario.list.elements,
});

module.exports = connect(
  mapStateToProps,
  null,
)(AntipassbackDetails);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/antipassbacks/AntipassbackDetails.js